import { extractParams, generateHash, generatePath, generateReactRouterPath, RouteConfig, withPath, } from '@famly/vet_navigation_route-config';
export { 
/**
 * @deprecated import from '@famly/vet_navigation_route-config'
 */
extractParams, 
/**
 * @deprecated import from '@famly/vet_navigation_route-config'
 */
generateHash, 
/**
 * @deprecated import from '@famly/vet_navigation_route-config'
 */
generatePath, 
/**
 * @deprecated import from '@famly/vet_navigation_route-config'
 */
generateReactRouterPath, 
/**
 * @deprecated import from '@famly/vet_navigation_route-config'
 */
RouteConfig, 
/**
 * @deprecated import from '@famly/vet_navigation_route-config'
 */
withPath, };
export default RouteConfig;
